import { get } from './requests'

export const getSeeds = ({ email, query, skip = 0 }) =>
  get(
    [`url-similarity-seeds`],
    { removeTrailingSlash: true },
    {
      ...(email && { 'created_by.email': email }),
      ...(query && { q: query }),
      sort: 'updated_at,-1',
      status: 'processed',
      limit: 10,
      skip,
    }
  )

export const getSeedsEnum = () => get([`/url-similarity-seeds/enum/created_by.email`])
